<div class="spinner-container d-flex fd-col jc-center ai-center">
  <h4>{{ message }}</h4>
  <mat-spinner [diameter]="diameter"></mat-spinner>
</div>